// extracted by mini-css-extract-plugin
export default {"container":"hero_container","logo":"hero_logo","title":"hero_title","buttonWrapper":"hero_buttonWrapper"};